export default "/wordpress.a48a6690-2bcb5b.png";